<template>
  <v-dialog
    v-model="dialog"
    scrollable
    persistent
    :overlay="false"
    max-width="500px"
    transition="dialog-transition"
  >
    <v-card>
      <v-toolbar color="primary" dark>Cambiar Contraseña</v-toolbar>
      <v-card-text class="px-5 pt-5">
        <v-form @submit.prevent="cambiar" ref="form" v-model="valid" lazy-validation>
          <v-text-field
            prepend-icon="lock"
            label="Contraseña Actual"
            require
            v-model="password.antigua"
            :rules="antiguaRules"
             :disabled="loading"
            :append-icon="eye? 'visibility' : 'visibility_off'"
            @click:append="() => (eye = !eye)"
            :type="eye ? 'password' : 'text'"
            autocomplete="password"
          ></v-text-field>
          <v-text-field
            prepend-icon="lock"
            label=" Nueva Contraseña"
            require
            :rules="passwordRule"
            v-model="password.claveRaw.first"
            :append-icon="eye? 'visibility' : 'visibility_off'"
            @click:append="() => (eye = !eye)"
            :type="eye ? 'password' : 'text'"
            :disabled="loading"
            autocomplete="password"
          ></v-text-field>
          <v-text-field
            prepend-icon="lock"
            label="Repita Nueva Contraseña"
            require
            :rules="rpasswordRule"
             :disabled="loading"
            v-model="password.claveRaw.second"
            :append-icon="eye? 'visibility' : 'visibility_off'"
            @click:append="() => (eye = !eye)"
            :type="eye ? 'password' : 'text'"
            autocomplete="password"
          ></v-text-field>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="error" text @click="cancelar"  :disabled="loading">cancelar</v-btn>
        <v-btn color="primary" @click="cambiar" :loading="loading" :disabled="!valid">modificar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  props: {
    dialog: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      eye: true,
      valid: false,
      password: {
        antigua: null,
        claveRaw: {
          first: null,
          second: null
        }
      },
      antiguaRules:[
        v => !!v || "Campo requerido"
      ],
      passwordRule:[
        v => !!v || "Campo requerido",
        v =>  v && v.length>=8 || "La contraseña debe ser al menos 8 caracteres",
        v => v!=this.password.antigua|| "Debe introducir una contraseña diferente a la antigua"
      ],
      rpasswordRule:[
        v=>v==this.password.claveRaw.first || "Debe coincidir con la Nueva Contraseña"
      ]
    };
  },
   computed: {
    loading() {
      return this.$store.state.loading;
    }
  },
  methods: {
    cancelar() {
      this.$refs.form.reset()
      this.$emit("cancelar");
    },
    cambiar() {
      if (this.$refs.form.validate()) {
        this.$store.commit('setLoading',true);
        var config = {
          headers: {
            authorization: "Bearer " + this.$store.state.token
          }
        };
        this.$http
          .patch(`${this.$apiUrl}/usuario/password`, this.password, config)
          .then(response => {
             this.$store.commit('setLoading',false);
            this.$emit("confirmado");
          })
          .catch(error => {
            this.$store.commit('setLoading',false);
            this.$store.commit("setError", error.response.data.mensaje);
          });
      }
    }
  }
};
</script>
